import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IUrunEnvanterAnalizi_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IUrunEnvanterAnalizi_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetItemInventoryTotal: any[];
  GetItemInventoryTotal_dummy: any[];
  ListUser: any[];
  ListUser_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  GetItemInventoryGrid: any[];
  GetItemInventoryGrid_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp816046Visible: "visible" | "hidden";
}

export class UrunEnvanterAnalizi_ScreenBase extends React.PureComponent<
  IUrunEnvanterAnalizi_ScreenProps,
  any
> {
  urunenvanteranalizi_644897_value_kuikaSelectBoxRef: React.RefObject<any>;
  urunenvanteranalizi_38920_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4532f5b4-5b68-470f-8303-24acccbb647b",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 214860, PropertyName: "label", Value: "Profil" },
        { Id: 185584, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 321259, PropertyName: "value", Value: "Ürün Envanter Analizi" },
        { Id: 554173, PropertyName: "value", Value: "Envanter Miktarı" },
        { Id: 263376, PropertyName: "value", Value: "adet" },
        { Id: 653069, PropertyName: "value", Value: "metrekare" },
        {
          Id: 721076,
          PropertyName: "value",
          Value: "Koleksiyon Bazında Envanter Analizi",
        },
        { Id: 730563, PropertyName: "value", Value: "Ürün Arayınız" },
        {
          Id: 521865,
          PropertyName: "value",
          Value: "Filtreyi Çalıştırmak İçin Ara Butonuna Tıklayın",
        },
        { Id: 680034, PropertyName: "value", Value: "Koleksiyona göre ara" },
        { Id: 589788, PropertyName: "placeholder", Value: "Koleksiyon Ara" },
        { Id: 116795, PropertyName: "value", Value: "Desene göre ara" },
        { Id: 252336, PropertyName: "placeholder", Value: "Desen Ara" },
        { Id: 363931, PropertyName: "value", Value: "Ebata göre ara" },
        { Id: 28223, PropertyName: "placeholder", Value: "Ebat ara" },
        {
          Id: 644897,
          PropertyName: "placeholder",
          Value: "miktar/metrekare/tutar",
        },
        { Id: 178454, PropertyName: "label", Value: "Ara" },
        { Id: 530330, PropertyName: "label", Value: "Temizle" },
        {
          Id: 38920,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 97762, PropertyName: "title", Value: "Title" },
        { Id: 657610, PropertyName: "value", Value: "Ürün adı" },
        {
          Id: 733260,
          PropertyName: "value",
          Value: "[datafield:productdescription]",
        },
        { Id: 3684, PropertyName: "value", Value: "Adet" },
        {
          Id: 937904,
          PropertyName: "value",
          Value: "[datafield:inventoryqty1]",
        },
        { Id: 746267, PropertyName: "value", Value: "Mr2" },
        {
          Id: 417635,
          PropertyName: "value",
          Value: "[datafield:inventoryqty2]",
        },
        { Id: 981268, PropertyName: "value", Value: "Birim" },
        {
          Id: 2826,
          PropertyName: "value",
          Value: "[datafield:unitofmeasurecode1]",
        },
        { Id: 852622, PropertyName: "value", Value: "Tutar" },
        {
          Id: 877330,
          PropertyName: "value",
          Value: "[datafield:envantertutar]",
        },
        {
          Id: 823484,
          PropertyName: "value",
          Value: "[datafield:envantertutar2]",
        },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.urunenvanteranalizi_589788_value_kuikaTextInputRef = React.createRef();
    this.urunenvanteranalizi_252336_value_kuikaTextInputRef = React.createRef();
    this.urunenvanteranalizi_28223_value_kuikaTextInputRef = React.createRef();
    this.urunenvanteranalizi_644897_value_kuikaSelectBoxRef = React.createRef();
    this.urunenvanteranalizi_38920_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetItemInventoryTotal: [],
      ListUser: [],
      GetImage: [],
      GetItemInventoryGrid: [],
      SetValueOf: "",
      dataSource_644897: [
        { key: "0", text: "Miktar Bazında" },
        { key: "1", text: "Metrekare Bazında" },
        { key: "2", text: "Tutar Bazında" },
      ],
      isComp816046Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("urunenvanteranalizi", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.UrunEnvanterAnaliziPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("urunenvanteranalizi", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("urunenvanteranalizi", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.UrunEnvanterAnaliziPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  UrunEnvanterAnaliziPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      kUserId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.ListUser !== undefined
            ? stateVars.ListUser?.length > 0
              ? stateVars.ListUser[0].id
              : null
            : this.state.ListUser?.length > 0
            ? this.state.ListUser[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunEnvanterAnalizi/UrunEnvanterAnaliziPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItemInventoryTotal = result?.data.getItemInventoryTotal;
    formVars.urunenvanteranalizi_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemInventoryTotal !== undefined
        ? stateVars.GetItemInventoryTotal?.length > 0
          ? stateVars.GetItemInventoryTotal[0].inventoryQty1
          : null
        : this.state.GetItemInventoryTotal?.length > 0
        ? this.state.GetItemInventoryTotal[0].inventoryQty1
        : null
    );
    formVars.urunenvanteranalizi_890807_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemInventoryTotal !== undefined
        ? stateVars.GetItemInventoryTotal?.length > 0
          ? stateVars.GetItemInventoryTotal[0].inventoryQty2
          : null
        : this.state.GetItemInventoryTotal?.length > 0
        ? this.state.GetItemInventoryTotal[0].inventoryQty2
        : null
    );
    stateVars.ListUser = result?.data.listUser;
    stateVars.GetImage = result?.data.getImage;
    formVars.urunenvanteranalizi_604624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.UrunEnvanterAnaliziPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunEnvanterAnaliziPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.urunenvanteranalizi_604624_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.urunenvanteranalizi_512255_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemInventoryTotal !== undefined
        ? stateVars.GetItemInventoryTotal?.length > 0
          ? stateVars.GetItemInventoryTotal[0].inventoryQty1
          : null
        : this.state.GetItemInventoryTotal?.length > 0
        ? this.state.GetItemInventoryTotal[0].inventoryQty1
        : null
    );

    formVars.urunenvanteranalizi_890807_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetItemInventoryTotal !== undefined
        ? stateVars.GetItemInventoryTotal?.length > 0
          ? stateVars.GetItemInventoryTotal[0].inventoryQty2
          : null
        : this.state.GetItemInventoryTotal?.length > 0
        ? this.state.GetItemInventoryTotal[0].inventoryQty2
        : null
    );

    stateVars.isComp816046Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetItemInventoryGrid !== undefined
            ? stateVars.GetItemInventoryGrid?.length > 0
              ? stateVars.GetItemInventoryGrid[0].productCode
              : null
            : this.state.GetItemInventoryGrid?.length > 0
            ? this.state.GetItemInventoryGrid[0].productCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  UrunEnvanterAnaliziComponent_891895_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UrunEnvanterAnalizi",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "526188",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunEnvanterAnaliziComponent_214860_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UrunEnvanterAnalizi",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunEnvanterAnaliziComponent_185584_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunEnvanterAnaliziComponent_529556_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "UrunEnvanterAnalizi",
      "UEAKoleksiyonStok",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunEnvanterAnaliziComponent_644897_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunenvanteranalizi_589788_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunenvanteranalizi_252336_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunenvanteranalizi_28223_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Filter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunenvanteranalizi_644897_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunEnvanterAnalizi/UrunEnvanterAnaliziComponent_644897_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItemInventoryGrid = result?.data.getItemInventoryGrid;

    stateVars.isComp816046Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetItemInventoryGrid !== undefined
            ? stateVars.GetItemInventoryGrid?.length > 0
              ? stateVars.GetItemInventoryGrid[0].productCode
              : null
            : this.state.GetItemInventoryGrid?.length > 0
            ? this.state.GetItemInventoryGrid[0].productCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunEnvanterAnaliziComponent_644897_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunEnvanterAnaliziComponent_644897_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_38920 =
      stateVars.GetItemInventoryGrid ?? this.state.GetItemInventoryGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunEnvanterAnaliziComponent_178454_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunenvanteranalizi_589788_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunenvanteranalizi_252336_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "urunenvanteranalizi_28223_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Filter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "urunenvanteranalizi_644897_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunEnvanterAnalizi/UrunEnvanterAnaliziComponent_178454_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItemInventoryGrid = result?.data.getItemInventoryGrid;

    stateVars.isComp816046Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetItemInventoryGrid !== undefined
            ? stateVars.GetItemInventoryGrid?.length > 0
              ? stateVars.GetItemInventoryGrid[0].productCode
              : null
            : this.state.GetItemInventoryGrid?.length > 0
            ? this.state.GetItemInventoryGrid[0].productCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunEnvanterAnaliziComponent_178454_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunEnvanterAnaliziComponent_178454_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_38920 =
      stateVars.GetItemInventoryGrid ?? this.state.GetItemInventoryGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  UrunEnvanterAnaliziComponent_530330_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        null,
        "string"
      ),
      Filter_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "UrunEnvanterAnalizi/UrunEnvanterAnaliziComponent_530330_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetItemInventoryGrid = result?.data.getItemInventoryGrid;

    stateVars.isComp816046Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetItemInventoryGrid !== undefined
            ? stateVars.GetItemInventoryGrid?.length > 0
              ? stateVars.GetItemInventoryGrid[0].productCode
              : null
            : this.state.GetItemInventoryGrid?.length > 0
            ? this.state.GetItemInventoryGrid[0].productCode
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.UrunEnvanterAnaliziComponent_530330_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  UrunEnvanterAnaliziComponent_530330_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "urunenvanteranalizi_644897_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("0", "string"),
      null,
      "Key"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "urunenvanteranalizi_589788_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "urunenvanteranalizi_252336_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "urunenvanteranalizi_28223_value",
        "string"
      ),
      "",
      null,
      false
    );

    stateVars.dataSource_38920 =
      stateVars.GetItemInventoryGrid ?? this.state.GetItemInventoryGrid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [526188, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.UrunEnvanterAnaliziPageInit();
    }
  }
}
